import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useGetApplication, useSubmitStepIsLoading } from '~/controllers/wizard';
import { useDraftIsStale } from '~/controllers/draft';
import theme from '~/constants/theme';
import { isReadOnly } from '~/utils/isReadOnly';
import Button, { ButtonProps } from '~/components/Button';
import colors from '~/constants/colors';

interface Props extends ButtonProps {
  formName?: string;
  children?: React.ReactNode;
  isPriceLoading?: boolean;
}

const WizardContinueButton: FC<Props> = (props) => {
  const { formName, disabled, isPriceLoading, children, loading: parseLoading, ...rest } = props;
  const { t } = useTranslation();
  const [isLoading] = useSubmitStepIsLoading();
  const { isStale } = useDraftIsStale();
  const applicationQuery = useGetApplication();
  const uneditableStep = isReadOnly(applicationQuery.data);

  return (
    <StyledButton
      className="WizardContinueButton"
      htmlType="submit"
      form={formName}
      size="large"
      type="primary"
      block
      loading={isLoading || isPriceLoading || parseLoading || isStale}
      disabled={disabled}
      {...rest}
    // id="WizardContinueButton"
    >
      {children ?? t('Continue')}
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  @media (max-width: ${theme.breakpoints.xs}px) {
    width: 100% !important;
  }

  ${({ disabled }) =>
    disabled &&
    `
    border-radius: 8px !important;
    border: 1px solid #DADADA !important;
    background: #F5F9FC !important;
    color: ${colors.grey[600]} !important;
    pointer-events: none !important;
    box-shadow: none !important;
    `}
`;

export default WizardContinueButton;
